import { useQuery } from "@tanstack/vue-query";
import { officesKeys } from "../queryHookKeys";
import { fetchOffices } from "../actions-query/offices";

// Queries

export const useFetchOffices = (group_id: number) => {
  return useQuery({
    queryKey: officesKeys.list(group_id),
    queryFn: async () => {
      const response = await fetchOffices(group_id);
      return response.items;
    },
  });
};
